import React from 'react';
import SvgIcon from './SvgIcon';

const Dark = props => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.985 4.794L12 0 9.015 4.794l-5.5-1.28 1.279 5.501L0 12l4.794 2.985-1.28 5.5 5.501-1.279L12 24l2.985-4.794 5.5 1.28-1.279-5.501L24 12l-4.794-2.985 1.28-5.5-5.501 1.279zm-1.077 3.96A5.153 5.153 0 017 13.603a5.155 5.155 0 0010-1.755A5.155 5.155 0 0013.602 7c.198.548.306 1.139.306 1.755z"
            fill="currentColor"
        />
    </SvgIcon>
);

Dark.displayName = 'DarkIcon';

export default Dark;
